import { useCallback } from "react"
import { resetAuthState } from "../../application/states/auth/auth-slice"
import { clearChat } from "../../application/states/chat"
import { store } from "../../application/states/store"
import { executeAlert } from "../../application/states/toast-alert"
import { useLocalStorageService } from "../local-storage"
import { useNavigationService } from "../navigation"

// Encerra a sessão do usuário (401, inatividade): limpa os dados locais, vai para o login e avisa o motivo.
// Executa uma única vez, mesmo que seja chamado várias vezes ao mesmo tempo (o token zerado bloqueia as próximas).
export const useEndSession = () => {
  const { removeItem } = useLocalStorageService()
  const { navigateTo } = useNavigationService()

  const endSession = useCallback((message: string) => {
    if (!store.getState().auth.token) return

    store.dispatch(clearChat())
    removeItem({ key: 'ACCESS_TOKEN' })
    removeItem({ key: 'REQUIRES_TWO_FACTOR_ACTIVATION' })
    removeItem({ key: 'TWO_FACTOR_USER_ID' })
    removeItem({ key: 'LAST_ACTIVITY' })
    store.dispatch(resetAuthState())
    navigateTo({
      route: '/authentication/login'
    })
    // Depois dos catch das telas, para não ser sobrescrita pelo erro genérico da requisição
    setTimeout(() => store.dispatch(executeAlert({ message, type: 'warning' })), 500)
  }, [removeItem, navigateTo])

  return {
    endSession
  }
}
